module.exports = __webpack_public_path__ + "static/media/relians.6373481f.png";